import React, { Component } from 'react';
import Wizard from './Wizard';
import { Col, Container, Row } from 'reactstrap';
import Report from './Report';
import { MortgageCalculator } from '../../../components/MortgageCalculator/MortgageCalculator';
import { debounce } from 'lodash';
import { connect } from 'react-redux';
import { mortgageCalcHide, mortgageCalcSave, fetchTaxCalcIfNeeded } from '../TaxActions'

class TaxCalculator extends Component {
    displayName = TaxCalculator.name

    componentDidMount() {
        this.props.fetchTaxCalcIfNeeded();
    }

    debouncedCalc = debounce((e) => {
        this.props.fetchTaxCalcIfNeeded();
    }, 1000)

    componentDidUpdate(prevProps) {
        this.debouncedCalc();
    }
        
    render() {
        return (
            <Container fluid>
                <Row>
                    <Col sm="12" md="4">
                        {
                            this.props.view == 'calc' &&
                            <Wizard />
                        }
                        {
                            this.props.view == 'mcalc' &&
                            <MortgageCalculator mortCalcHide={this.props.mortgageCalcHide} mortCalcSave={this.props.mortgageCalcSave} />
                        }
                    </Col>
                    <Col sm="12" md="8">
                        <Report />
                    </Col>
                </Row>
            </Container>
        );
    }
}



const mapStateToProps = state => {
    return state.tax;
};

export default connect(
    mapStateToProps,
    { mortgageCalcHide, mortgageCalcSave, fetchTaxCalcIfNeeded }
)(TaxCalculator)


// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/Components/TaxCalculator.jsx